import type { DynamicImageDimensions } from '@/lib/images/dynamic-image';

/** Critical tiles: one DIS width so LCP gets a single preload, not a full picture srcset. */
export const CRITICAL_IMAGE_WIDTHS = [320] satisfies DynamicImageDimensions;

/**
 * Tile share of the viewport: 2 columns full-bleed below `lg`, then 3 and 4 beside the 360px sidebar.
 * `vw` cannot express `(100vw - 360px) / n`, so each value is its band's widest ratio — never under-
 * advertising. `2xl` is the last band the image resolver can address; it reads Tailwind's built-in
 * screens, not the `4xl`-`6xl` tokens the grid uses above it.
 */
export const PRODUCT_GRID_IMAGE_WIDTHS = {
    base: '50vw',
    lg: '26vw',
    '2xl': '21vw',
} satisfies DynamicImageDimensions;
